export default __webpack_public_path__ + "static/media/ttr-dot-com-bg-2.bda4bb54.svg";